import React from 'react';
import {injectStripe,CardElement} from 'react-stripe-elements';
import {
    Grid,
    Row,
    Col
  } from "react-bootstrap";  
import CardSection from '../CheckoutForms/CardSection';
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import { WEB_URL } from "variables/Variables.jsx";

class CreditCardDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        cardElement : null,
        updatingCardDetails : false,
        errorMessage : ''
    }
  }

  render() {
    return (
    <div>
        <Grid fluid>
        <form onSubmit={this.handleSubmit}>
            <Row className="show-grid">
                <Col xs={12} md={8}>
                    <label>
                        New Card details
                        <CardElement onChange={this.handleChange} onReady={this.handleUpdateCardReady} style={{base: {fontSize: '14px'}}} hidePostalCode={true} />
                        <div className="error" role="alert">
                            {this.state.errorMessage}
                        </div>
                    </label>
                </Col>
            </Row>
            <Row className="show-grid">
                <Col xs={12} md={8}>
                <ProgressButton bsStyle="info" fill type="submit" runningAsyncOperation={this.state.updatingCardDetails} onClick={(e) => {this.handleUpdateCardDetails(e);}}>
                    <i className="fa fa-credit-card" style={{paddingRight:25}}></i>Save New Card
                </ProgressButton>                    
                </Col>
            </Row>
        </form>
      </Grid>
      </div>
    );
  }

  handleChange = ({error}) => {
    if (error) {
      this.setState({errorMessage: error.message});
    }
  };

  handleUpdateCardDetails(e){
    e.preventDefault();
    var _this = this;

    if((isFromEU && isFromEU() || (_this.props.authDetail.detail.BillingCountry && euCountries.includes(_this.props.authDetail.detail.BillingCountry))) && !_this.props.authDetail.detail.TaxID){
        _this.props.triggerNotification('error','tc','Please update your VAT/Tax ID before updating your payment details');    
        return;
    }

    if (this.props.stripe) {
        this.props.stripe.createToken().then(function(result){
            if(!result.error){
                _this.setState({updatingCardDetails : true});

                _this.props.stripe.createPaymentMethod({
                    type: 'card',
                    card: _this.state.cardElement
                })
                .then(function(result) {
                    if(result.paymentMethod){
                        fetch("https://"+WEB_URL+"/account/api/creative-services",{
                            'method' : 'POST',
                            'headers' : { 'Content-Type' : 'application/json'},
                            //'body' : 'action=attachpaymentmethod&paymentMethod='+result.paymentMethod.id+'&token='+_this.props.authDetail.token+'&checksum='+_this.props.authDetail.checksum+'&email='+_this.props.authDetail.detail.email
                            'body' : JSON.stringify({'action':'attachpaymentmethod','paymentMethod':result.paymentMethod.id,'token':_this.props.authDetail.token,'checksum':_this.props.authDetail.checksum,'email':_this.props.authDetail.detail.email})
                        }).then(res => res.json())
                        .then(
                            (response) => {
                                if(response.result == 'SUCCESS'){
                                    _this.props.triggerNotification('success','tc','Your card details have been updated');


                                    fetch("https://"+WEB_URL+"/account/api/login",{
                                        'method' : 'POST',
                                        'headers' : { 'Content-Type' : 'application/json'},
                                        //'body' : 'token='+_this.props.authDetail.token+'&email='+_this.props.authDetail.checksum+'&detail=true',
                                        'body' : JSON.stringify({'token':_this.props.authDetail.token,'email':_this.props.authDetail.checksum,'detail':true}),
                                        'credentials': 'same-origin'
                                        }).then(res => res.json()).then((result) => {
                                                if(result.auth == 'AUTH_OK'){
                                                    _this.props.setLoggedIn(result,_this.props.authEmail);
                                                }else{
                                                    _this.props.setLoggedIn(false);    
                                                }
                                            },
                                                (error) => {
                                                    _this.props.setLoggedIn(false);
                                                }
                                            )

                                }else{
                                    _this.props.triggerNotification('error','tc','Error updating the card details. Please contact us for further assistance.');    
                                }

                                _this.setState({updatingCardDetails : false});
                            },
                            (error) => {
                                _this.props.triggerNotification('error','tc','Error updating the card details. Please contact us for further assistance.');
                                _this.setState({updatingCardDetails : false});
                            }
                        )
                    }else{
                        _this.props.triggerNotification('error','tc','Error updating the card details. Please contact us for further assistance.');   
                        _this.setState({updatingCardDetails : false});
                    }
                
                });
            }
        });
    }

    
  }

  handleUpdateCardReady = element => {
    this.setState({ cardElement: element });
  };
  

}

export default injectStripe(CreditCardDetails);


const TIMEZONE = {
    ANDORRA: {
        ANDORRA: 'Europe/Andorra'
    },
    AUSTRIA: {
        VIENNA: 'Europe/Vienna'
    },
    BELGIUM: {
        BRUSSELS: 'Europe/Brussels'
    },
    BULGARIA: {
        SOFIA: 'Europe/Sofia'
    },
    CROATIA: {
        ZAGREB: 'Europe/Zagreb'
    },
    CYPRUS: {
        NICOSIA_EUROPE: 'Europe/Nicosia',
        NICOSIA_ASIA: 'Asia/Nicosia',
        FAMAGUSTA: 'Asia/Famagusta'
    },
    CZECHIA: {
        PRAGUE: 'Europe/Prague'
    },
    DENMARK: {
        COPENHAGEN: 'Europe/Copenhagen',
        FAROE: 'Atlantic/Faroe'
    },
    ESTONIA: {
        TALLINN: 'Europe/Tallinn'
    },
    FINLAND: {
        HELSINKI: 'Europe/Helsinki',
        MARIEHAMN: 'Europe/Mariehamn'
    },
    FRANCE: {
        PARIS: 'Europe/Paris',
        CAYENNE: 'America/Cayenne',
        GUADELOUPE: 'America/Guadeloupe',
        MARIGOT: 'America/Marigot',
        MARTINIQUE: 'America/Martinique',
        MAYOTTE: 'Indian/Mayotte',
        REUNION: 'Indian/Reunion'
    },
    GERMANY: {
        BERLIN: 'Europe/Berlin',
        BUSINGEN: 'Europe/Busingen'
    },
    GREECE: {
        ATHENS: 'Europe/Athens'
    },
    HUNGARY: {
        BUDAPEST: 'Europe/Budapest'
    },
    ICELAND: {
        REYKJAVIK: 'Atlantic/Reykjavik'
    },
    IRELAND: {
        DUBLIN: 'Europe/Dublin'
    },
    ITALY: {
        ROME: 'Europe/Rome'
    },
    LATVIA: {
        RIGA: 'Europe/Riga'
    },
    LIECHTENSTEIN: {
        VADUZ: 'Europe/Vaduz'
    },
    LITHUANIA: {
        VILNIUS: 'Europe/Vilnius'
    },
    LUXEMBOURG: {
        LUXEMBOURG: 'Europe/Luxembourg'
    },
    MALTA: {
        MALTA: 'Europe/Malta'
    },
    MONACO: {
        MONACO: 'Europe/Monaco'
    },
    NETHERLANDS: {
        AMSTERDAM: 'Europe/Amsterdam',
        ARUBA: 'America/Aruba',
        CURACAO: 'America/Curacao',
        KRALENDIJK: 'America/Kralendijk',
        LOWER_PRINCES: 'America/Lower_Princes'
    },
    NORWAY: {
        OSLO: 'Europe/Oslo',
        JAN_MAYEN: 'Atlantic/Jan_Mayen',
        LONGYEARBYEN: 'Arctic/Longyearbyen'
    },
    POLAND: {
        WARSAW: 'Europe/Warsaw'
    },
    PORTUGAL: {
        LISBON: 'Europe/Lisbon',
        AZORES: 'Atlantic/Azores',
        MADEIRA: 'Atlantic/Madeira'
    },
    ROMANIA: {
        BUCHAREST: 'Europe/Bucharest'
    },
    SAN_MARINO: {
        SAN_MARINO: 'Europe/San_Marino'
    },
    SLOVAKIA: {
        BRATISLAVA: 'Europe/Bratislava'
    },
    SLOVENIA: {
        LJUBLJANA: 'Europe/Ljubljana'
    },
    SPAIN: {
        MADRID: 'Europe/Madrid',
        CANARY: 'Atlantic/Canary',
        CEUTA: 'Africa/Ceuta'
    },
    SWEDEN: {
        STOCKHOLM: 'Europe/Stockholm'
    },
    SWITZERLAND: {
        ZURICH: 'Europe/Zurich'
    },
    VATICAN: {
        VATICAN: 'Europe/Vatican'
    }
  };
  const EU_TIMEZONE = [
    TIMEZONE.AUSTRIA.VIENNA,
    TIMEZONE.BELGIUM.BRUSSELS,
    TIMEZONE.BULGARIA.SOFIA,
    TIMEZONE.CROATIA.ZAGREB,
    TIMEZONE.CYPRUS.NICOSIA_EUROPE,
    TIMEZONE.CYPRUS.NICOSIA_ASIA,
    TIMEZONE.CYPRUS.FAMAGUSTA,
    TIMEZONE.CZECHIA.PRAGUE,
    TIMEZONE.DENMARK.COPENHAGEN,
    TIMEZONE.ESTONIA.TALLINN,
    TIMEZONE.FINLAND.HELSINKI,
    TIMEZONE.FINLAND.MARIEHAMN,
    TIMEZONE.FRANCE.PARIS,
    TIMEZONE.GERMANY.BERLIN,
    TIMEZONE.GREECE.ATHENS,
    TIMEZONE.HUNGARY.BUDAPEST,
    TIMEZONE.IRELAND.DUBLIN,
    TIMEZONE.ITALY.ROME,
    TIMEZONE.LATVIA.RIGA,
    TIMEZONE.LITHUANIA.VILNIUS,
    TIMEZONE.LUXEMBOURG.LUXEMBOURG,
    TIMEZONE.MALTA.MALTA,
    TIMEZONE.NETHERLANDS.AMSTERDAM,
    TIMEZONE.POLAND.WARSAW,
    TIMEZONE.PORTUGAL.LISBON,
    TIMEZONE.ROMANIA.BUCHAREST,
    TIMEZONE.SLOVAKIA.BRATISLAVA,
    TIMEZONE.SLOVENIA.LJUBLJANA,
    TIMEZONE.SPAIN.MADRID,
    TIMEZONE.SWEDEN.STOCKHOLM,
    TIMEZONE.FRANCE.CAYENNE,
    TIMEZONE.FRANCE.GUADELOUPE,
    TIMEZONE.FRANCE.MARIGOT,
    TIMEZONE.FRANCE.MARTINIQUE,
    TIMEZONE.FRANCE.MAYOTTE,
    TIMEZONE.FRANCE.REUNION,
    TIMEZONE.PORTUGAL.AZORES,
    TIMEZONE.PORTUGAL.MADEIRA,
    TIMEZONE.SPAIN.CANARY
  ];
  const EEA_EFTA_TIMEZONE = [
    TIMEZONE.ICELAND.REYKJAVIK,
    TIMEZONE.LIECHTENSTEIN.VADUZ,
    TIMEZONE.NORWAY.OSLO,
    TIMEZONE.NORWAY.JAN_MAYEN
  ];
  const EEA_TIMEZONE = [
    ...EU_TIMEZONE,
    ...EEA_EFTA_TIMEZONE
  ];
  const EFTA_TIMEZONE = [
    TIMEZONE.SWITZERLAND.ZURICH,
    ...EEA_EFTA_TIMEZONE
  ];
  const SCHENGEN_TIMEZONE = [
    TIMEZONE.AUSTRIA.VIENNA,
    TIMEZONE.BELGIUM.BRUSSELS,
    TIMEZONE.BULGARIA.SOFIA,
    TIMEZONE.CROATIA.ZAGREB,
    TIMEZONE.CZECHIA.PRAGUE,
    TIMEZONE.DENMARK.COPENHAGEN,
    TIMEZONE.ESTONIA.TALLINN,
    TIMEZONE.FINLAND.HELSINKI,
    TIMEZONE.FINLAND.MARIEHAMN,
    TIMEZONE.FRANCE.PARIS,
    TIMEZONE.GERMANY.BERLIN,
    TIMEZONE.GREECE.ATHENS,
    TIMEZONE.HUNGARY.BUDAPEST,
    TIMEZONE.ITALY.ROME,
    TIMEZONE.LATVIA.RIGA,
    TIMEZONE.LITHUANIA.VILNIUS,
    TIMEZONE.LUXEMBOURG.LUXEMBOURG,
    TIMEZONE.MALTA.MALTA,
    TIMEZONE.NETHERLANDS.AMSTERDAM,
    TIMEZONE.POLAND.WARSAW,
    TIMEZONE.PORTUGAL.LISBON,
    TIMEZONE.PORTUGAL.AZORES,
    TIMEZONE.PORTUGAL.MADEIRA,
    TIMEZONE.ROMANIA.BUCHAREST,
    TIMEZONE.SLOVAKIA.BRATISLAVA,
    TIMEZONE.SLOVENIA.LJUBLJANA,
    TIMEZONE.SPAIN.MADRID,
    TIMEZONE.SPAIN.CANARY,
    TIMEZONE.SWEDEN.STOCKHOLM,
    TIMEZONE.ANDORRA.ANDORRA,
    TIMEZONE.GERMANY.BUSINGEN,
    TIMEZONE.ICELAND.REYKJAVIK,
    TIMEZONE.LIECHTENSTEIN.VADUZ,
    TIMEZONE.MONACO.MONACO,
    TIMEZONE.NORWAY.OSLO,
    TIMEZONE.SAN_MARINO.SAN_MARINO,
    TIMEZONE.SPAIN.CEUTA,
    TIMEZONE.SWITZERLAND.ZURICH,
    TIMEZONE.VATICAN.VATICAN
  ];
  const isTimezoneIn = (tz) => { var _a; return typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat) && tz.includes(Intl.DateTimeFormat().resolvedOptions().timeZone); };
  const isFromEU = () => isTimezoneIn(EU_TIMEZONE);
  const isFromEEA = () => isTimezoneIn(EEA_TIMEZONE);
  const isFromEFTA = () => isTimezoneIn(EFTA_TIMEZONE);
  const isFromSchengen = () => isTimezoneIn(SCHENGEN_TIMEZONE);
  const euCountries = [
      "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark",
      "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy",
      "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal",
      "Romania", "Slovakia", "Slovenia", "Spain", "Sweden", "United Kingdom"
  ];